import React from "react";

const Panel = props => {
    return (
        <div className="card">
            <div className="card-header">
                <h2 className="title title--primary title--md">
                    {props.title}
                </h2>
            </div>
            <div className="card-body">{props.children}</div>
        </div>
    );
};

export default Panel;
